const n = "_container_vfw8c_1", t = {
  container: n
};
export {
  n as container,
  t as default
};
